import { b as __spreadArray, a as __assign } from './tslib.es6-21effb23.js';
import React__default, { useState, useMemo } from 'react';

var defaultTheme = {
    action: "#482DEB",
    warning: "#FF9911",
    negative: "#EC0049",
    positive: "#008800",
    neutral: "#006FFB",
};
var staticColors = {
    "color-white": "#FFFFFF",
    "color-black": "#1A1B23",
    "color-slate": "#6f749b",
};
var interfaceColors = {
    "color-ui-interface": "#556680",
    "color-ui-interface-mid": "#39465b",
    "color-ui-interface-dark": "#262e3b",
    "color-ui-interface-5": "#F7FAFD",
    "color-ui-interface-10": "#F0F4FA",
    "color-ui-interface-20": "#E4ECF6",
    "color-ui-interface-30": "#D7E1EF",
    "color-ui-interface-40": "#BBCADD",
    "color-ui-interface-50": "#A6B7CE",
    "color-ui-interface-60": "#93A5BD",
    "color-ui-interface-70": "#8598B2",
    "color-ui-interface-80": "#7586A3",
    "color-ui-interface-90": "#667793",
};
var dataColors = {
    "color-data-green": "#39A775",
    "color-data-cyan": "#28A2B9",
    "color-data-light-blue": "#3E97F8",
    "color-data-purple": "#6164EA",
    "color-data-violet": "#9A65E7",
    "color-data-pink": "#E75A85",
    "color-data-orange": "#F5923E",
};
var defaultShades = {
    action: {
        mid: "#2F1BA6",
        dark: "#15095D",
    },
    warning: {
        mid: "#DB7D00",
        dark: "#754300",
    },
    negative: {
        mid: "#B80039",
        dark: "#750024",
    },
    positive: {
        mid: "#006100",
        dark: "#004D00",
    },
    neutral: {
        mid: "#0058C7",
        dark: "#004194",
    },
};

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

const hexCharacters = 'a-f\\d';
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, 'gi');
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, 'i');

var hexRgb = (hex, options = {}) => {
	if (typeof hex !== 'string' || nonHexChars.test(hex) || !validHexSize.test(hex)) {
		throw new TypeError('Expected a valid hex string');
	}

	hex = hex.replace(/^#/, '');
	let alphaFromHex = 1;

	if (hex.length === 8) {
		alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
		hex = hex.slice(0, 6);
	}

	if (hex.length === 4) {
		alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
		hex = hex.slice(0, 3);
	}

	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	const number = Number.parseInt(hex, 16);
	const red = number >> 16;
	const green = (number >> 8) & 255;
	const blue = number & 255;
	const alpha = typeof options.alpha === 'number' ? options.alpha : alphaFromHex;

	if (options.format === 'array') {
		return [red, green, blue, alpha];
	}

	if (options.format === 'css') {
		const alphaString = alpha === 1 ? '' : ` / ${Number((alpha * 100).toFixed(2))}%`;
		return `rgb(${red} ${green} ${blue}${alphaString})`;
	}

	return {red, green, blue, alpha};
};

const pattern$8 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/;
var hexRe$1 = new RegExp(pattern$8, 'i');

const float$1 = '-?\\d*(?:\\.\\d+)';

const number$1 = `(${float$1}?)`;
const percentage$1 = `(${float$1}?%)`;
const numberOrPercentage$1 = `(${float$1}?%?)`;

const pattern$1$1 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,
    \\s*${percentage$1}\\s*,
    \\s*${percentage$1}\\s*
    (?:,\\s*${numberOrPercentage$1}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var hsl3Re$1 = new RegExp(pattern$1$1);

const pattern$2$1 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*
    \\s+${percentage$1}
    \\s+${percentage$1}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage$1}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var hsl4Re$1 = new RegExp(pattern$2$1);

const pattern$3$1 = `^
  rgba?\\(
    \\s*${number$1}\\s*,
    \\s*${number$1}\\s*,
    \\s*${number$1}\\s*
    (?:,\\s*${numberOrPercentage$1}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var rgb3NumberRe$1 = new RegExp(pattern$3$1);

const pattern$4$1 = `^
  rgba?\\(
    \\s*${percentage$1}\\s*,
    \\s*${percentage$1}\\s*,
    \\s*${percentage$1}\\s*
    (?:,\\s*${numberOrPercentage$1}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var rgb3PercentageRe$1 = new RegExp(pattern$4$1);

const pattern$5$1 = `^
  rgba?\\(
    \\s*${number$1}
    \\s+${number$1}
    \\s+${number$1}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage$1}\\s*)?
  \\)
$
`.replace(/\n|\s/g, '');

var rgb4NumberRe$1 = new RegExp(pattern$5$1);

const pattern$6$1 = `^
  rgba?\\(
    \\s*${percentage$1}
    \\s+${percentage$1}
    \\s+${percentage$1}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage$1}\\s*)?
  \\)
$
`.replace(/\n|\s/g, '');

var rgb4PercentageRe$1 = new RegExp(pattern$6$1);

const pattern$7$1 = /^transparent$/;
var transparentRe$1 = new RegExp(pattern$7$1, 'i');

const clamp$3 = (num, min, max) => Math.min(Math.max(min, num), max);

/* 500 => 255, -10 => 0, 128 => 128 */
const parseRGB$1 = (num) => {
  let n = num;
  if (typeof n !== 'number') n = n.endsWith('%') ? (parseFloat(n) * 255) / 100 : parseFloat(n);
  return clamp$3(Math.round(n), 0, 255);
};

/* 200 => 100, -100 => 0, 50 => 50 */
const parsePercentage$1 = (percentage) => clamp$3(parseFloat(percentage), 0, 100);

/* '50%' => 5.0, 200 => 1, -10 => 0 */
function parseAlpha$1(alpha) {
  let a = alpha;
  if (typeof a !== 'number') a = a.endsWith('%') ? parseFloat(a) / 100 : parseFloat(a);
  return clamp$3(a, 0, 1);
}

function getHEX$1(hex) {
  const [r, g, b, a] = hexRgb(hex, { format: 'array' });
  return getRGB$1([null, ...[r, g, b, a]]);
}

function getHSL$1([, h, s, l, a = 1]) {
  let hh = h;
  if (hh.endsWith('turn')) {
    hh = (parseFloat(hh) * 360) / 1;
  } else if (hh.endsWith('rad')) {
    hh = Math.round((parseFloat(hh) * 180) / Math.PI);
  } else {
    hh = parseFloat(hh);
  }
  return {
    type: 'hsl',
    values: [hh, parsePercentage$1(s), parsePercentage$1(l)],
    alpha: parseAlpha$1(a === null ? 1 : a)
  };
}

function getRGB$1([, r, g, b, a = 1]) {
  return {
    type: 'rgb',
    values: [r, g, b].map(parseRGB$1),
    alpha: parseAlpha$1(a === null ? 1 : a)
  };
}

/**
 * parse-css-color
 * @version v0.1.2
 * @link http://github.com/noeldelgado/parse-css-color/
 * @license MIT
 */

const parseCSSColor$1 = (str) => {
  if (typeof str !== 'string') return null;

  const hex = hexRe$1.exec(str);
  if (hex) return getHEX$1(hex[0]);

  const hsl = hsl4Re$1.exec(str) || hsl3Re$1.exec(str);
  if (hsl) return getHSL$1(hsl);

  const rgb =
    rgb4NumberRe$1.exec(str) ||
    rgb4PercentageRe$1.exec(str) ||
    rgb3NumberRe$1.exec(str) ||
    rgb3PercentageRe$1.exec(str);
  if (rgb) return getRGB$1(rgb);

  if (transparentRe$1.exec(str)) return getRGB$1([null, 0, 0, 0, 0]);

  const cn = colorName[str.toLowerCase()];
  if (cn) return getRGB$1([null, cn[0], cn[1], cn[2], 1]);

  return null;
};

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

var hsl2rgb_1 = hsl2rgb;

function clamp$2(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

var clamp_1 = clamp$2;

var clamp$1 = clamp_1;

function componentToHex(c) {
  var value = Math.round(clamp$1(c, 0, 255));
  var hex   = value.toString(16);

  return hex.length == 1 ? "0" + hex : hex;
}

function rgb2hex(rgb) {
  var alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";

  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
}

var rgb2hex_1 = rgb2hex;

function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

var rgb2hsl_1 = rgb2hsl;

/**
 * mix-css-color
 * @version v0.2.0
 * @link http://github.com/noeldelgado/mix-css-color/
 * @license MIT
 */

function parseColor(color) {
  const res = parseCSSColor$1(color);
  if (res === null) return null;
  if (res.type === 'hsl') res.values = hsl2rgb_1(res.values);
  return res;
}

/**
 * Mix two colors together in variable proportion. Opacity is included in the calculations.
 * Copyright (c) 2006-2009 Hampton Catlin, Natalie Weizenbaum, and Chris Eppstein
 * http://sass-lang.com
 * @see https://github.com/less/less.js/blob/cae5021358a5fca932c32ed071f652403d07def8/lib/less/functions/color.js#L302
 */
function mix(color1, color2, percentage = 50) {
  const c1 = parseColor(color1);
  const c2 = parseColor(color2);

  if (!c1 || !c2) return null;

  const p = Math.min(Math.max(0, percentage), 100) / 100.0;
  const w = p * 2 - 1;
  const a = c1.alpha - c2.alpha;
  const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
  const w2 = 1 - w1;
  const [r, g, b] = c1.values.map((c, i) => Math.round(c1.values[i] * w1 + c2.values[i] * w2));
  const alpha = parseFloat((c1.alpha * p + c2.alpha * (1 - p)).toFixed(8));

  return {
    hex: rgb2hex_1([r, g, b]),
    hexa: rgb2hex_1([r, g, b, alpha]),
    rgba: [r, g, b, alpha],
    hsla: [...rgb2hsl_1([r, g, b]).map(Math.round), alpha]
  };
}

const pattern = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/;
var hexRe = new RegExp(pattern, 'i');

const float = '-?\\d*(?:\\.\\d+)';

const number = `(${float}?)`;
const percentage = `(${float}?%)`;
const numberOrPercentage = `(${float}?%?)`;

const pattern$1 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var hsl3Re = new RegExp(pattern$1);

const pattern$2 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var hsl4Re = new RegExp(pattern$2);

const pattern$3 = `^
  rgba?\\(
    \\s*${number}\\s*,
    \\s*${number}\\s*,
    \\s*${number}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var rgb3NumberRe = new RegExp(pattern$3);

const pattern$4 = `^
  rgba?\\(
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, '');

var rgb3PercentageRe = new RegExp(pattern$4);

const pattern$5 = `^
  rgba?\\(
    \\s*${number}
    \\s+${number}
    \\s+${number}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, '');

var rgb4NumberRe = new RegExp(pattern$5);

const pattern$6 = `^
  rgba?\\(
    \\s*${percentage}
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, '');

var rgb4PercentageRe = new RegExp(pattern$6);

const pattern$7 = /^transparent$/;
var transparentRe = new RegExp(pattern$7, 'i');

const clamp = (num, min, max) => Math.min(Math.max(min, num), max);

/* 500 => 255, -10 => 0, 128 => 128 */
const parseRGB = (num) => {
  let n = num;
  if (typeof n !== 'number') n = n.endsWith('%') ? (parseFloat(n) * 255) / 100 : parseFloat(n);
  return clamp(Math.round(n), 0, 255);
};

/* 200 => 100, -100 => 0, 50 => 50 */
const parsePercentage = (percentage) => clamp(parseFloat(percentage), 0, 100);

/* '50%' => 5.0, 200 => 1, -10 => 0 */
function parseAlpha(alpha) {
  let a = alpha;
  if (typeof a !== 'number') a = a.endsWith('%') ? parseFloat(a) / 100 : parseFloat(a);
  return clamp(a, 0, 1);
}

function getHEX(hex) {
  const [r, g, b, a] = hexRgb(hex, { format: 'array' });
  return getRGB([null, ...[r, g, b, a]]);
}

function getHSL([, h, s, l, a = 1]) {
  let hh = h;
  if (hh.endsWith('turn')) {
    hh = (parseFloat(hh) * 360) / 1;
  } else if (hh.endsWith('rad')) {
    hh = Math.round((parseFloat(hh) * 180) / Math.PI);
  } else {
    hh = parseFloat(hh);
  }
  return {
    type: 'hsl',
    values: [hh, parsePercentage(s), parsePercentage(l)],
    alpha: parseAlpha(a === null ? 1 : a)
  };
}

function getRGB([, r, g, b, a = 1]) {
  return {
    type: 'rgb',
    values: [r, g, b].map(parseRGB),
    alpha: parseAlpha(a === null ? 1 : a)
  };
}

/**
 * parse-css-color
 * @version v0.2.0
 * @link http://github.com/noeldelgado/parse-css-color/
 * @license MIT
 */

const parseCSSColor = (str) => {
  if (typeof str !== 'string') return null;

  const hex = hexRe.exec(str);
  if (hex) return getHEX(hex[0]);

  const hsl = hsl4Re.exec(str) || hsl3Re.exec(str);
  if (hsl) return getHSL(hsl);

  const rgb =
    rgb4NumberRe.exec(str) ||
    rgb4PercentageRe.exec(str) ||
    rgb3NumberRe.exec(str) ||
    rgb3PercentageRe.exec(str);
  if (rgb) return getRGB(rgb);

  if (transparentRe.exec(str)) return getRGB([null, 0, 0, 0, 0]);

  const cn = colorName[str.toLowerCase()];
  if (cn) return getRGB([null, cn[0], cn[1], cn[2], 1]);

  return null;
};

/**
 * values.js - Get the tints and shades of a color
 * @version v2.1.1
 * @link http://noeldelgado.github.io/values.js/
 * @license MIT
 */
const defaultNumberParam = (v, d) => (v === null || isNaN(v) || typeof v === 'string' ? d : v);
class Values {
  constructor(color = '#000', type = 'base', weight = 0) {
    [this.rgb, this.alpha, this.type, this.weight] = [[0, 0, 0], 1, type, weight];
    const c = color === null ? '#000' : color;
    if (typeof c !== 'string') throw new TypeError(`Input should be a string: ${c}`);
    const parsed = parseCSSColor(c);
    if (!parsed) throw new Error(`Unable to parse color from string: ${c}`);
    return this[`_setFrom${parsed.type.toUpperCase()}`]([...parsed.values, parsed.alpha]);
  }
  get hex() {
    return this.hexString().replace(/^#/, '');
  }
  setColor(color) {
    const parsed = parseCSSColor(color);
    if (!parsed) return null;
    return this[`_setFrom${parsed.type.toUpperCase()}`]([...parsed.values, parsed.alpha]);
  }
  tint(weight, w = defaultNumberParam(weight, 50)) {
    return new Values(`rgb(${mix('#fff', this.rgbString(), w).rgba})`, 'tint', w);
  }
  shade(weight, w = defaultNumberParam(weight, 50)) {
    return new Values(`rgb(${mix('#000', this.rgbString(), w).rgba})`, 'shade', w);
  }
  tints(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.tint((i + 1) * w));
  }
  shades(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.shade((i + 1) * w));
  }
  all(weight = 10) {
    return [...this.tints(weight).reverse(), Object.assign(this), ...this.shades(weight)];
  }
  hexString() {
    return rgb2hex_1(this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]);
  }
  rgbString() {
    const channels = (this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]).join(', ');
    return `${this.alpha >= 1 ? 'rgb' : 'rgba'}(${channels})`;
  }
  getBrightness() {
    return Math.round((this.rgb.reduce((a, b) => a + b) / (255 * 3)) * 100);
  }
  _setFromRGB([r, g, b, a]) {
    [this.rgb, this.alpha] = [[r, g, b], a];
    return this;
  }
  _setFromHSL([h, s, l, a]) {
    [this.rgb, this.alpha] = [hsl2rgb_1([h, s, l]).map(Math.round), a];
    return this;
  }
}
Values.VERSION = 'v2.1.1';

// Checks whether a string is a valid CSS colour (Hex, RGB or named colour)
var isValidColor = function (strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color !== "";
};
var buildTints = function (name, color) {
    var colors = [];
    if (!isValidColor(color)) {
        color = defaultTheme[name];
    }
    colors.push([
        "color-ui-".concat(name, "-5"),
        new Values(color).tint(95).hexString().toUpperCase(),
    ]);
    for (var i = 1; i <= 9; i++) {
        colors.push([
            "color-ui-".concat(name, "-").concat(i * 10),
            new Values(color)
                .tint(100 - i * 10)
                .hexString()
                .toUpperCase(),
        ]);
    }
    return colors;
};
var buildShades = function (name, color) {
    var _a;
    var colors = [];
    if (!isValidColor(color)) {
        color = (_a = defaultTheme[name]) !== null && _a !== void 0 ? _a : defaultTheme.action;
    }
    // If the color is one of the defaults, we have custom shades so use them
    if (color === defaultTheme[name]) {
        colors.push(["color-ui-".concat(name, "-mid"), defaultShades[name].mid]);
        colors.push(["color-ui-".concat(name, "-dark"), defaultShades[name].dark]);
    }
    else {
        colors.push([
            "color-ui-".concat(name, "-mid"),
            new Values(color).shade(20).hexString().toUpperCase(),
        ]);
        colors.push([
            "color-ui-".concat(name, "-dark"),
            new Values(color).shade(40).hexString().toUpperCase(),
        ]);
    }
    colors.push(["color-ui-".concat(name), color]);
    return colors;
};
var buildTheme = function (theme) {
    var dynamicColors = Object.entries(theme).reduce(function (obj, curr) {
        var _a = curr, name = _a[0], color = _a[1];
        var colors = __spreadArray(__spreadArray([], buildTints(name, color), true), buildShades(name, color), true);
        return __assign(__assign({}, obj), Object.fromEntries(colors));
    }, {});
    return __assign(__assign(__assign(__assign({}, interfaceColors), dynamicColors), staticColors), dataColors);
};

var ThemeContext = React__default.createContext(null);
var useTheme = function () {
    var context = React__default.useContext(ThemeContext);
    if (!context) {
        throw new Error("You must initialise an `ThemeProvider` before using Orchard theming");
    }
    return context;
};
var ThemeProvider = function (_a) {
    var children = _a.children, overridesProp = _a.overrides;
    var Provider = ThemeContext.Provider;
    var _b = useState(overridesProp || {}), overrides = _b[0], setOverrides = _b[1];
    var currentTheme = useMemo(function () { return (__assign(__assign({}, defaultTheme), overrides)); }, [overrides]);
    var builtColors = useMemo(function () {
        return buildTheme(currentTheme);
    }, [currentTheme]);
    var asCssVars = useMemo(function () {
        return Object.entries(builtColors).reduce(function (obj, _a) {
            var color = _a[0], value = _a[1];
            obj["--".concat(color)] = value;
            return obj;
        }, {});
    }, [builtColors]);
    return (React__default.createElement(Provider, { value: {
            setOverrides: setOverrides,
            colors: builtColors,
        } }, children(asCssVars)));
};

export { ThemeProvider as T, defaultTheme as d, useTheme as u };
